import { createContext, useContext } from 'react';

export interface AuthVisualState {
  email: string;
  passwordMask: string;
}
export const AuthVisualContext = createContext<(value: AuthVisualState) => void>(() => undefined);
export const useAuthVisual = () => useContext(AuthVisualContext);
